import type { ChainModifiers, Entry, EntrySkeletonType } from 'contentful'
import { computed, getCurrentInstance, onBeforeUnmount, type Ref } from 'vue'
import {
  useAvailableShops,
  useCurrentShop,
} from '@scayle/storefront-nuxt/composables'
import { useRoute } from '#app/composables/router'

export function useContentfulEditor<T extends EntrySkeletonType>(
  content?: Ref<Entry<T, ChainModifiers, string> | null | undefined>,
) {
  const route = useRoute()
  const isInEditorMode = '_editorMode' in route.query
  const instance = getCurrentInstance()

  const currentShop = useCurrentShop()
  const availableShops = useAvailableShops()

  const currentShopLocale = computed(() => {
    return (
      availableShops.value.find(
        (shop) => shop.locale === currentShop.value.locale,
      )?.locale ?? 'en-GB'
    )
  })

  if (isInEditorMode && import.meta.client) {
    import('@contentful/live-preview').then(({ ContentfulLivePreview }) => {
      if (!content?.value) {
        return
      }

      // TODO: Remove this once we have a proper locale handling
      ContentfulLivePreview.init({ locale: currentShopLocale.value })
      const unsubscribe = ContentfulLivePreview.subscribe({
        data: content.value,
        callback(update) {
          content.value = update as Entry<T, ChainModifiers, string>
        },
      })
      onBeforeUnmount(() => unsubscribe(), instance)
    })
  }

  return {
    isInEditorMode,
  }
}
